import { Component } from '@angular/core';

@Component({
  selector: 'app-events-social-responsibilities',
  templateUrl: './events-social-responsibilities.component.html',
  styleUrl: './events-social-responsibilities.component.scss'
})
export class EventsSocialResponsibilitiesComponent {

}
